module.exports = __webpack_public_path__ + "img/summary_item_bg3.5fdc0251.png";